import React from "react";
import { ColumnsType } from "antd/es/table";
import { SuccessStatusSVG, SuccessSVG, UnSuccessSVG } from "assets";
import "./TabPay.scss";
import { ColumnsEdit } from "types/models/column-table-edit";
import { formatToCurrencyType } from "helper/common";
import { FIELD_TYPE } from "types/enums";
import TTTTTypeColumn from "components/common/ColumnColors/KCBTypeColumn/TTTTTypeColumn";
const { INPUT, SELECT, DATE, AUTO_COMPLETE } = FIELD_TYPE;

const columnsTabPay: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "2%",
    fixed: "left",
    align: "center",
  },
  {
    title: "Nội dung",
    dataIndex: "content",
    key: "content",
    // width: "18%",
    editable: true,
  },
  {
    title: "Ngày chỉ định",
    dataIndex: "ngayChiDinh",
    key: "ngayChiDinh",
    width: "6%",
    editable: true,
    align: "center",
  },
  {
    title: "BH",
    dataIndex: "theBaoHiem",
    key: "theBaoHiem",
    width: "3%",
    // render: bh => {
    //   if (bh == 1) return <SuccessSVG className='un-bh' />;
    //   if (bh == 2) return <SuccessSVG />;
    // },
    align: "center",
  },
  {
    title: "Thẻ BN",
    dataIndex: "theBenhNhan",
    key: "theBenhNhan",
    width: "3%",
    // render: bh => {
    //   if (bh == 1) return <SuccessSVG className='un-bh' />;
    //   if (bh == 2) return <SuccessSVG />;
    // },
    align: "center",
  },
  {
    title: "Đơn giá BV",
    dataIndex: "donGiaBenhVien",
    key: "donGiaBenhVien",
    width: "6%",
    editable: true,
    align: "right",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }

  },
  {
    title: "Đơn giá BH",
    dataIndex: "donGiaBaoHiem",
    key: "donGiaBaoHiem",
    width: "6%",
    align: "right",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }

  },
  {
    title: "SL",
    dataIndex: "soLuong",
    key: "soLuong",
    width: "3%",
    // width: "18%",
    align: "right"
  },
  {
    title: "Thành tiền",
    dataIndex: "thanhTien",
    key: "thanhTien",
    width: "6%",
    align: "right",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }
  },
  {
    title: "BH chi trả",
    dataIndex: "bhpay",
    key: "bhpay",
    width: "6%",
    align: "right",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }
  },
  {
    title: "BN cùng chi trả",
    dataIndex: "bnpay",
    key: "bnpay",
    width: "6%",
    editable: true,
    align: "right",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }
  },
  {
    title: "BN chi trả",
    dataIndex: "bnpaid",
    key: "bnpaid",
    width: "6%",
    editable: true,
    align: "right",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    render: text => {
      let textTT;
      if (text == 0) {
        textTT = "Chưa thanh toán";
      } 
      else if (text == 1) {
        textTT = "Đã thanh toán";
      }
      else if (text == 2) {
        textTT = "Đã tạm ứng";
      }
      else if (text == 3) {
        textTT = "Đã hoàn phí";
      }
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
    // width: "15%",
    // render: (status) => {
    //   if (status == 0)
    //     return (
    //       <div className="pay-status">
    //         <div className="icon-success">
    //           <UnSuccessSVG />
    //         </div>
    //         <div style={{ color: "red" }}>Chưa thanh toán</div>
    //       </div>
    //     );
    //   if (status == 1)
    //     return (
    //       <div className="pay-status">
    //         <div className="icon-success">
    //           <SuccessStatusSVG className="pay-tab-success" />
    //         </div>
    //         <div style={{ color: "#00B335" }}>Đã thanh toán</div>
    //       </div>
    //     );
    //   if (status == 2)
    //     return (
    //       <div className="pay-status">
    //         <div className="icon-success">
    //           <UnSuccessSVG className="cancel-icon" />
    //         </div>
    //         <div style={{ color: "#999999" }}>Đã tạm ứng</div>
    //       </div>
    //     );
    //   // if (status == 3)
    //   //   return (
    //   //     <div className="pay-status">
    //   //       <div className="icon-success">
    //   //         <SuccessStatusSVG className="pay-tab-success" />
    //   //       </div>
    //   //       <div style={{ color: "#00B335" }}>Đề nghị hoàn phí</div>
    //   //     </div>
    //   //   );
    //   if (status == 3)
    //     return (
    //       <div className="pay-status">
    //         <div className="icon-success">
    //           <SuccessStatusSVG className="refunds-success" />
    //         </div>
    //         <div style={{ color: "#999999" }}>Đã hoàn phí</div>
    //       </div>
    //     );
    // },
  },
  {
    title: "Tên thu ngân",
    dataIndex: "tenThuNgan",
    key: "tenThuNgan",
    // width: "10%",
  },
  {
    title: "Thời gian thanh toán",
    dataIndex: "thoiGianThanhToan",
    key: "thoiGianThanhToan",
    // width: "10%",
    align: "center",
  },
  {
    title: "Số tiền miễn giảm",
    dataIndex: "soTienMienGiam",
    key: "soTienMienGiam",
    align: "right",
    width: "6%",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }
    // width: "10%",
  },
  {
    title: "Lý do miễn giảm",
    dataIndex: "lyDoMienGiam",
    key: "lyDoMienGiam",
    // width: "10%",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    fixed: "right",
    width: "3%",
    align: "center",
  },
];

// const columnTable: any = [
//   {
//     title: "STT",
//     dataIndex: "stt",
//     key: "stt",
//     render: (text, record, index) => index + 1,
//     width: "4%",
//     fixed: "left",
//     align: "center",
//   },
//   {
//     title: "Hình thức thanh toán",
//     dataIndex: "hinhThucThanhToan",
//     key: "hinhThucThanhToan",
//     width: "24%",
//     // type: SELECT,
//   },
//   {
//     title: "Số tiền GD",
//     dataIndex: "soTienGiaoDich",
//     key: "soTienGiaoDich",
//     width: "24%",
//     // type: INPUT,
//   },
//   {
//     title: "Mã giao dịch",
//     dataIndex: "maGiaoDich",
//     key: "maGiaoDich",
//     width: "24%",
//     // type: INPUT,
//   },
//   {
//     title: "Số tiền trả lại",
//     dataIndex: "soTienTraLai",
//     key: "soTienTraLai",
//     width: "24%",
//     // type: INPUT,
//   },
//   {
//     title: "",
//     dataIndex: "action",
//     key: "action",
//     width: "4%",
//   },
// ]

export { columnsTabPay};
